import React from 'react';
import {
  ChartData,
  ScatterDataPoint,
} from 'chart.js';
import { Line } from 'react-chartjs-2';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import Box from '@mui/material/Box';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';

import ChartWrapper from './ChartWrapper';
import { useMetrics } from '../../Contexts/metrics-context';
import { getSnrPerOperator } from '../../Utils/metricsSerializer';
import chartColors from './../../Constants/colors';
import defaultGraphOptions from './../../Constants/defaultGraphOptions';

export default function ChartSnrPerOperator() {
  const { stateMetrics } = useMetrics();
  const [operator, setOperator] = React.useState('all');
  const [measureType, setMeasureType] = React.useState('all');

  const snrProcessedPerOperator = React.useMemo(
    () => getSnrPerOperator(stateMetrics.metricsOutput, stateMetrics.chartsFormat),
    [stateMetrics.metricsOutput, stateMetrics.chartsFormat],
  );

  /*eslint-disable */
  const data_: ChartData<
    'line',
    (number | ScatterDataPoint | null)[],
    unknown
  > = { datasets: [] };
  Object.keys(snrProcessedPerOperator.data)
    .filter(
      (key) =>
        (operator === 'all' || key.includes(operator)) &&
        (measureType === 'all' || key.includes(measureType)),
    )
    .map((value, index) => {
      data_.datasets.push({
        type: 'line' as const,
        label: value,
        data: snrProcessedPerOperator.data[value] as any,
        borderColor: chartColors.lineCharts.borders[index],
        backgroundColor: chartColors.lineCharts.backgrounds[index],
      });
    });
  /*eslint-enable */

  return (
    <React.Fragment>
      <ChartWrapper title="SNR per operator">
        <div>
          <FormControl sx={{ m: 2, minWidth: 120 }} size="small">
            <InputLabel id="demo-select-small">Operator</InputLabel>
            <Select
              value={operator}
              size="small"
              label="Operator"
              onChange={(e) => setOperator(e.target.value)}
            >
              <MenuItem value="all">All</MenuItem>
              {snrProcessedPerOperator.entities.map((value) => (
                <MenuItem key={value} value={value}>
                  {value}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <FormControl sx={{ m: 2, minWidth: 120 }} size="small">
            <InputLabel id="demo-select-small">SNR Measures</InputLabel>
            <Select
              value={measureType}
              size="small"
              label="Type"
              onChange={(e) => setMeasureType(e.target.value)}
            >
              <MenuItem value="all">All</MenuItem>
              {snrProcessedPerOperator.measuresTypes.map((value) => (
                <MenuItem key={value} value={value}>
                  {value}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <Box style={{ height: '400px', margin: 'auto' }}>
            <Line options={defaultGraphOptions.line} data={data_} />
          </Box>
        </div>
      </ChartWrapper>
    </React.Fragment>
  );
}
